import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWaterFlowRateList as getWaterFlowRateListApi,
	getWaterFlowRateListQuery as getWaterFlowRateListQueryApi,
	getWaterFlowRateListItem as getWaterFlowRateListItemApi,
	addNewWaterFlowRateListApi,
	updateWaterFlowRateListApi,
	deleteWaterFlowRateListApi,
} from '../../helpers/water_flow_rate_list/api_helper';

export const getWaterFlowRateList = createAsyncThunk(
	'waterFlowRateList/getWaterFlowRateList',
	async (params = {}) => {
		try {
			const response = await getWaterFlowRateListApi(params);
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los caudales.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWaterFlowRateListQuery = createAsyncThunk(
	'waterFlowRateList/getWaterFlowRateListQuery',
	async params => {
		try {
			const response = getWaterFlowRateListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWaterFlowRateListItem = createAsyncThunk(
	'waterFlowRateList/getWaterFlowRateListItem',
	async ({ id, populate = [] }) => {
		try {
			const response = await getWaterFlowRateListItemApi(id, populate);
			return response;
		} catch (error) {
			toast.error('Error al obtener el caudal.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWaterFlowRateList = createAsyncThunk(
	'waterFlowRateList/addNewWaterFlowRateList',
	async water_flow_rate_list => {
		try {
			const response = await addNewWaterFlowRateListApi(water_flow_rate_list);
			toast.success('Caudal agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el caudal.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWaterFlowRateList = createAsyncThunk(
	'waterFlowRateList/updateWaterFlowRateList',
	async water_flow_rate_list => {
		try {
			const response = await updateWaterFlowRateListApi(water_flow_rate_list);
			toast.success('Caudal actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el caudal.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWaterFlowRateList = createAsyncThunk(
	'waterFlowRateList/deleteWaterFlowRateList',
	async water_flow_rate_list => {
		try {
			const response = await deleteWaterFlowRateListApi(water_flow_rate_list._id);
			toast.success('Caudal eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return water_flow_rate_list;
		} catch (error) {
			toast.error('Error al eliminar el caudal.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
